import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal } from 'antd'
import DebtForm from './DebtForm'
import { users, cancellationRequests } from '@services/api'

@inject((store: any) => {
    const { popupStore, authStore, subscriptionsStore } = store

    return {
        popupStore,
        authStore,
        subscriptionsStore
    }
})
@observer
export default class NewCommissionFromCancellation extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            searchClientResults: [],
            credit: false,
            selectedClient: {},
            clientSubscription: '',
            subscription: '',
            clientAmount: '',
            commissionRate: 0,
            clientCommissions: '',
            prevClientIdFromProps: '',
            agentInfo: {},
            clientLookupDone: false,
            loading: false
        }
    }

    componentDidMount() {
        const {
            popupStore: { info }
        } = this.props
        const { agentInfo, selectedClient } = this.state

        if (info.client_id && info.client_id !== selectedClient.client_id) {
            // this.getAgentClientCommissions()

            this.searchAndSelectClient(info.client_id)
        }

        if (info.agentInfo && info.agentInfo.id !== agentInfo.id) {
            // this.getAgentClientCommissions()

            this.setState({
                agentInfo: info.agentInfo
                // clientCommissions: JSON.parse(info.commissions)
            })

            this.getAgentClientCommissions()
        }
    }

    // componentDidUpdate(prevProps, prevState) {

    //     const { popupStore: { info } } = this.props
    //     const { agentInfo, selectedClient } = this.state

    //     if (info.client_id && (info.client_id !== selectedClient.client_id)) {
    //         // this.getAgentClientCommissions()

    //         this.searchAndSelectClient(info.client_id)
    //     }

    //     if (info.agentInfo && (info.agentInfo.id !== agentInfo.id)) {
    //         // this.getAgentClientCommissions()

    //         this.setState({
    //             agentInfo: info.agentInfo,
    //             // clientCommissions: JSON.parse(info.commissions)
    //         })

    //         this.getAgentClientCommissions()

    //     }

    //     if (this.state.selectedClient.client_id) {
    //         if (this.state.selectedClient.client_id != prevState.selectedClient.client_id) {
    //             this.getAgentClientCommissions()
    //         }
    //     }

    // }

    getAgentClientCommissions = () => {
        const {
            popupStore: {
                info: { agentInfo, client_id }
            }
        } = this.props

        if (agentInfo && agentInfo.id && client_id) {
            this.setState({ loading: true }, () => {
                cancellationRequests
                    .getComissionsForCancellationReq({ agent_id: agentInfo.id, client_id })
                    .then(res => {
                        this.setState({ clientCommissions: res.data })
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .then(() => this.setState({ loading: false }))
            })
        }
    }

    onClose = (callback?) => {
        this.setState(
            {
                searchClientResults: [],
                credit: false,
                selectedClient: {},
                clientSubscription: '',
                subscription: '',
                clientAmount: '',
                commissionRate: 0,
                clientCommissions: '',
                prevClientIdFromProps: '',
                agentInfo: {},
                clientLookupDone: false
            },
            () => {
                this.props.popupStore.resetInfo()
                this.props.popupStore.togglePopup(false, null, true)

                if (typeof callback == 'function') {
                    callback()
                }
            }
        )
    }

    searchClient = inputClientId => {
        const {
            popupStore: {
                info: { agentInfo }
            }
        } = this.props
        const id = agentInfo && agentInfo.id

        // if (inputClientId) {
        if (!id) return
        users
            .instantClientSearch({ agent_id: id, client_id: inputClientId })
            .then(res => {
                if (Array.isArray(res.data)) {
                    this.setState({ searchClientResults: res.data })
                }
            })
            .catch(error => console.error(error))
        // }
    }

    searchAndSelectClient = clientId => {
        const {
            popupStore: {
                info: { agentInfo }
            }
        } = this.props
        if (clientId && agentInfo && agentInfo.id) {
            this.setState({ clientLookupDone: false })
            users
                .instantClientSearch({ agent_id: agentInfo.id, client_id: clientId })
                .then(res => {
                    if (Array.isArray(res.data)) {
                        this.setState({ searchClientResults: res.data, clientLookupDone: true }, () =>
                            this.selectClient(clientId)
                        )
                    } else {
                        this.setState({ clientLookupDone: true })
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.setState({ clientLookupDone: true })
                })
        } else {
            this.setState({ clientLookupDone: true })
        }
    }

    handleFormInput = e => {
        let field = e.target.id.split('-')[1]
        let value = e.target.value

        if (field === 'clientAmount') {
            value = value.replace(/[^0-9\.]/g, '')
        }

        this.setState({ [field]: value })
    }

    selectClient = selectedId => {
        const {
            subscriptionsStore: { subscriptions },
            popupStore: {
                info: {
                    subscription_id: subscription_id_from_cancellation_request,
                    special_subscription_id: special_subscription_id_from_cancellation_request
                }
            }
        } = this.props
        const { searchClientResults } = this.state

        let selectedClient = searchClientResults.find(({ client_id }) => client_id == selectedId)
        if (!selectedClient) {
            this.setState({
                selectedClient: {},
                clientSubscription: null,
                clientAmount: null,
                subscription: null,
                recentClientSubscriptions: []
            })
            return
        }

        let recentClientSubscriptions = []
        let subscription
        let select_id = 1
        let clientStandardSubscription, clientSpecialSubscription
        if (selectedClient.client_subscription) {
            const foundSubscription = subscriptions.find(
                ({ id }) => id === selectedClient.client_subscription.subscription_id
            )
            let found = foundSubscription ? JSON.parse(JSON.stringify(foundSubscription)) : null
            if (found) {
                clientStandardSubscription = found
                clientStandardSubscription.user_subscription_id = selectedClient.client_subscription.id
                clientStandardSubscription.subscription_status = selectedClient.client_subscription.subscription_status
                clientStandardSubscription.paid_at = selectedClient.client_subscription.paid_at
                clientStandardSubscription.select_id = select_id
                select_id++
                recentClientSubscriptions.push(found)
            }
        }

        if (selectedClient.specialSubscriptions) {
            selectedClient.specialSubscriptions.forEach(sub => {
                const foundSubscription = subscriptions.find(({ id }) => id === sub.subscription_id)
                let found = foundSubscription ? JSON.parse(JSON.stringify(foundSubscription)) : null
                if (found) {
                    found.user_subscription_id = sub.id
                    found.specialSub = true
                    found.subscription_status = sub.subscription_status
                    found.paid_at = sub.paid_at
                    found.dates_range = sub.dates_range
                    found.select_id = select_id
                    select_id++
                    recentClientSubscriptions.push(found)
                    clientSpecialSubscription = found
                    // if (!subscription) subscription = found
                }
            })
        }

        if (Array.isArray(selectedClient.client_subscription_history)) {
            selectedClient.client_subscription_history.forEach(hist => {
                const already = recentClientSubscriptions.find(sub => sub.user_subscription_id == hist.id)
                if (already) return

                const foundSubscription = subscriptions.find(({ id }) => id === hist.subscription_id)
                const found = foundSubscription ? JSON.parse(JSON.stringify(foundSubscription)) : null
                if (found) {
                    found.user_subscription_id = hist.id
                    found.subscription_status = hist.subscription_status
                    found.paid_at = hist.paid_at
                    found.select_id = select_id
                    select_id++
                    recentClientSubscriptions.push(found)
                }
            })
        }

        if (subscription_id_from_cancellation_request || special_subscription_id_from_cancellation_request) {
            subscription = recentClientSubscriptions.find(
                ({ user_subscription_id }) =>
                    user_subscription_id == subscription_id_from_cancellation_request ||
                    user_subscription_id == special_subscription_id_from_cancellation_request
            )
        }

        if (!subscription) {
            subscription = clientStandardSubscription || clientSpecialSubscription
        }

        if (recentClientSubscriptions.length) {
            const historyItem =
                Array.isArray(selectedClient.client_subscription_history) && subscription
                    ? selectedClient.client_subscription_history.find(
                          (h: any) => h.id == subscription.user_subscription_id
                      )
                    : null
            const clientAmount = historyItem && historyItem.price != null ? historyItem.price : subscription.price

            // let clientSubscription = selectedClient.client_subscription || selectedClient.specialSubscriptions[0]
            this.setState({
                selectedClient: selectedClient,
                clientSubscription: subscription, // clientSubscription,
                clientAmount,
                subscription,
                // clientCommissions,
                recentClientSubscriptions
            })
        } else {
            this.setState({
                selectedClient: selectedClient,
                clientSubscription: null,
                clientAmount: null,
                subscription: null,
                // clientCommissions,
                recentClientSubscriptions
            })
        }

        // if (selectedClient.client_subscription) {

        //     let subscription =
        //         subscriptions.find(({ id }) => id === selectedClient.client_subscription.subscription_id)

        //     let clientSubPrice = selectedClient.client_subscription.price

        //     this.setState({
        //         selectedClient: selectedClient,
        //         clientSubscription: selectedClient.client_subscription,
        //         clientAmount: (typeof clientSubPrice === 'number' && !Number.isNaN(clientSubPrice)) ? clientSubPrice : subscription.price,
        //         subscription
        //     })

        // } else {
        //     this.setState({
        //         selectedClient: selectedClient,
        //         clientSubscription: null,
        //         clientAmount: null,
        //         subscription: null
        //     })
        // }
    }

    getProductName = (subscription = { name: '', description: { title: '' } }) => {
        const name = subscription && subscription.name ? subscription.name : ''
        return name.includes('360') || name == 'Mediwho'
            ? 'MediWho360'
            : name.includes('Fly')
            ? 'MediWhoFly'
            : 'BestCare'
    }

    selectSubscription = selectedId => {
        const { recentClientSubscriptions, selectedClient } = this.state as any

        const subscription = recentClientSubscriptions.find(({ select_id }: any) => select_id == selectedId)

        const historyItem =
            Array.isArray(selectedClient.client_subscription_history) && subscription
                ? selectedClient.client_subscription_history.find((h: any) => h.id == subscription.user_subscription_id)
                : null

        const clientAmount =
            historyItem && historyItem.price != null ? historyItem.price : subscription && subscription.price

        this.setState({
            subscription,
            clientAmount
        })
    }

    safeParse = (value, fallback) => {
        if (!value) return fallback
        if (typeof value !== 'string') return value
        try {
            return JSON.parse(value)
        } catch (e) {
            return fallback
        }
    }

    setCommissionType = e => {
        this.setState({ credit: e.target.value })
    }

    render() {
        const {
            popupStore: { info },
            getAgentCommissions,
            getAgentCommissionTotals,
            subscriptionsStore: { subscriptions }
        } = this.props

        const {
            credit,
            searchClientResults,
            selectedClient,
            clientSubscription,
            clientAmount,
            subscription,
            clientCommissions,
            agentInfo,
            recentClientSubscriptions,
            clientLookupDone
        } = this.state

        let loading = true

        let productName = ''
        let commissionRate = 0
        let agentAmount = 0
        let date, payload

        const hasSelectedClient = !!(selectedClient && selectedClient.client_id)

        if (agentInfo.id && info.commissions && (hasSelectedClient || clientLookupDone)) {
            loading = false
            if (hasSelectedClient) {
                const percents = this.safeParse(agentInfo.percents, {})
                const agentType = agentInfo.isSubAgent ? 'sub' : 'general'

                if (subscription) {
                    productName = this.getProductName(subscription)
                    if (productName) {
                        const rateConfig =
                            percents[productName] && percents[productName][agentType]
                                ? percents[productName][agentType]
                                : 0
                        commissionRate = typeof rateConfig === 'number' ? rateConfig : 0
                        agentAmount = Number(clientAmount) * 12 * Number(commissionRate || 0)
                    }
                }

                date = new Date().toLocaleDateString('he-IS')

                payload = {
                    credit,
                    searchClientResults,
                    clientAmount,
                    subscription,
                    subscriptions,
                    agentInfo,
                    clientSubscription,
                    commissionRate,
                    agentAmount,
                    selectedClient,
                    productName,
                    percents,
                    agentType,
                    recentClientSubscriptions,
                    clientCommissions: clientCommissions // JSON.parse(info.commissions)
                }

            }
        }

        return (
            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'newCommissionFromCancellation'}
                title={`יצירת חיוב חדש`}
                footer={null}
                width="720px"
            >
                {loading && <h4>טוען</h4>}
                {!loading && !hasSelectedClient && <h4>לא נמצא לקוח מתאים ליצירת חיוב</h4>}
                {!loading && hasSelectedClient && (
                    <div style={{ ...style.column, ...style.content, paddingInline: '30px' }}>
                        <div style={{ ...style.formLine }}>
                            <span>תאריך</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <span>{date}</span>
                            </div>
                        </div>
                        <div style={{ ...style.formLine }}>
                            <span>שם ומזהה סוכן</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <span
                                    style={{ marginLeft: '30px' }}
                                >{`${agentInfo.first_name} ${agentInfo.last_name}`}</span>
                                <span>{agentInfo.id}</span>
                            </div>
                        </div>
                        <div style={{ ...style.formLine }}>
                            <span>הלקוח:</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <span style={{ marginLeft: '30px' }}>
                                    {`${selectedClient.client_first_name} ${selectedClient.client_last_name} - ${selectedClient.client_id}`}
                                </span>
                            </div>
                        </div>
                        <DebtForm
                            info={payload}
                            handleFormInput={this.handleFormInput}
                            selectSubscription={this.selectSubscription}
                            getAgentClientCommissions={this.getAgentClientCommissions}
                            getAgentCommissions={getAgentCommissions}
                            getAgentCommissionTotals={getAgentCommissionTotals}
                            onClose={this.onClose}
                        />
                    </div>
                )}
            </Modal>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    form: { width: '100%', paddingInline: '30px', margin: '30px 0' },
    line1: { display: 'flex', justifyContent: 'end' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    inputStyle: { width: '70%' },
    button: {
        height: '34px',
        width: '64px',
        background: 'white',
        borderRadius: '4px',
        border: 'solid #d9d9d9 1px',
        cursor: 'pointer',
        margin: '0 10px'
    }
}
